import Component from '@glimmer/component';

import themed from 'webapp/decorators/themed';

interface Args {
	extraClass?: string;
	theme?: 'grey' | 'white';
	size?: string;
}

@themed()
export default class BarLoaderComponent extends Component<Args> {
	declare themeClass: string; // from @themed
	declare sizeClass: string; // from @themed
	<template>
		<div class="bar-loader {{this.themeClass}} {{this.sizeClass}} {{@extraClass}}">
			<span class="bar bar1"></span>
			<span class="bar bar2"></span>
			<span class="bar bar3"></span>
		</div>
	</template>
}
